module.exports = __webpack_public_path__ + "static/media/coupons.50ebe52a.png";